export default {
    '-': "-",
    actions: "Действия",
    actions_with_selected: "Действия с выбранными",
    active: "Активен",
    add: "Добавить",
    add_attachment: "Добавить вложение",
    add_condition: "Добавить условие",
    afternoon: "День",
    all: "Все",
    app_is_in_maintenance_mode: "В приложениии ведутся технические работы. Мы обязательно скоро вернемся",
    are_you_sure_you_want_to_delete: "Вы уверены, что хотите удалить материал?",
    are_you_sure_you_want_to_logout: "Вы уверены, что хотите выйти?",
    assistant_id: "Ассистент",
    authorization: "Авторизация",
    authorize_in_system: "Авторизуйтесь в системе",
    azerbaijani: "Азербайджанский",
    balance: "Депозит",
    cancel: "Отмена",
    cancel_verb: "Отменить",
    change: "Изменить",
    change_password: "Изменить пароль",
    comment: "Комментарий",
    confirm_deletion: "Подтвердить удаление?",
    contacts: "Контакты",
    contains: "Содержит",
    continue: "Продолжить",
    credit: "Кредитный",
    currency: "Валюта",
    custom_role_rights_updated: "Изменены права доступа роли",
    delete: "Удалить",
    dentistry: "Стоматология",
    do_not_save: "Не сохранять",
    does_not_equal: "Не равно",
    done: "Готово",
    down: "Вниз",
    edit: "Редактировать",
    egisz_send_error: "Ошибка отправки в ЕГИСЗ",
    egisz_send_success: "Успешная отправка в ЕГИСЗ",
    email: "Email",
    email_required_for_password_reset: "Чтобы сбросить пароль этого пользователя, необходимо указать его email",
    end: "Окончание",
    english: "Английский",
    enter_username_to_reset_password: "Введите логин, чтобы получить ссылку для сброса пароля",
    equals: "Равно",
    error: "Ошибка",
    error_message: "Что-то пошло не так, операция не была завершена успешно",
    evening: "Вечер",
    excel: "Excel",
    exported_patients_to_excel: "Выгрузил пациентов в excel",
    exported_report_to_excel: "Выгрузил отчёт в excel",
    fact: "Факт",
    family_account_member_toggled: "Изменил активность участника семейного счета",
    family_account_updated: "Обновил состав семейного счета",
    file: "Файл",
    file_does_not_exist: "Файл не найден",
    file_size_is_too_big: "Размер файла слишком велик",
    filled: "Заполнено",
    filled_not_signed: "Заполнено / не подписано",
    filter: "Фильтр",
    finish: "Завершить",
    finishing_operation: "Завершение операции",
    forgot_password: "Забыли пароль?",
    from_to: "От {from} до {to}",
    general_cost: "Общая стоимость",
    general_medicine: "Общая медицина",
    general_slogan: "Облачное решение для управления современной клиникой",
    hide: "Спрятать",
    hide2: "Скрыть",
    home: "Главная",
    image: "Изображение",
    import: "Импорт",
    in_interval: "В интервале",
    input_field: "Поле для ввода текста",
    integration: "Интеграция",
    invalid_reset_link: "Эта ссылка для сброса пароля недействительна или срок ее действия истек",
    kazakh: "Казахский",
    kyrgyz: "Кыргызский",
    KZT: "KZT",
    language: "Язык",
    less: "Менее",
    links: "Ссылки",
    load_more: "Загрузить еще",
    logged: "Авторизован",
    logged_out: "Вышел из системы",
    login: "Логин",
    login_disclaimer: "Продолжая авторизацию в DENTIST PLUS, вы подтверждаете использование собственной учётной записи и принимаете ответственность за действия, совершённые с использованием ваших учётных данных. Передача учётных данных третьим лицам запрещена.",
    login_failed: "Неудачная попытка входа",
    login_locked_out: "Вход заблокирован (много попыток)",
    login_or_pass_incorrect: "Логин и / или пароль неверны",
    logout: "Выйти",
    main: "Главная",
    message: "Сообщение",
    module_unavailable: "Модуль недоступен",
    months: "Месяцев",
    more: "Более",
    more_2: "Еще",
    morning: "Утро",
    must_change_password_notice: "Необходимо сменить пароль, чтобы продолжить",
    name: "Имя",
    new_password: "Новый пароль",
    no: "Нет",
    no_data_available: "Данных пока нет",
    nonactive: "Неактивен",
    not_enough_rights_for_this_operation: "Недостаточно прав для данной операции",
    not_filled: "Не заполнено",
    nothing_found: "Ничего не найдено",
    old_password: "Старый пароль",
    on_page: "На странице",
    page_not_found: "Страница не найдена",
    password: "Пароль",
    password_changed: "Пароль изменен",
    password_confirm: "Подтверждение пароля",
    password_reset_link_sent: "Если такой аккаунт существует, на почту отправлена ссылка для сброса пароля",
    password_reset_failed: "Неудачная попытка сброса пароля",
    password_reset_requested: "Запросил сброс пароля",
    password_reset_succeeded: "Успешно сбросил пароль",
    passwords_do_not_match: "Пароли не совпадают",
    patient_search: "Поиск пациента",
    patient_tags_updated: "Обновил метки пациента",
    payment_expires_at: "Оплата истекает",
    phone: "Телефон",
    photo: "Фото",
    price: "Цена",
    print_noun: "Печать",
    professional: "Профессиональный",
    profile: "Профиль",
    program: "Программа",
    refresh: "Обновить",
    registration: "Регистрация",
    requirements: "Требования",
    reset: "Сброс",
    reset_password: "Сброс пароля",
    reset_password_email_note: "Пользователь получит на почту ссылку для установки нового пароля",
    reset_success: "Письмо для сброса отправлено на ваш E-mail",
    role: "Роль",
    russian: "Русский",
    save: "Сохранить",
    search: "Поиск",
    select: "Выбрать",
    send_reset_link: "Отправить ссылку",
    sent: "Отправлено",
    session_revoked: "Отозвал сессию",
    sessions_revoked: "Отозвал все остальные сессии",
    settings: "Настройки",
    show: "Показать",
    show_full: "Показать полностью",
    signin: "Войти",
    slogan: "Облачное решение для управления современной стоматологией",
    sorting: "Сортировка",
    staff_rights_updated: "Изменены права доступа сотрудника",
    staff_role_updated: "Изменена роль сотрудника",
    start: "Начать",
    start_noun: "Начало",
    status: "Статус",
    subscription_sum: "Сумма за подписку",
    success_message: "Операция прошла успешно",
    sum: "Сумма",
    system: "Системный",
    table_search: "Поиск по таблице",
    tech_specialist: "Технический специалист",
    text: "Текст",
    there_are_unsaved_changes: "Есть несохраненные изменения",
    this_module_is_not_in_tariff: "Этот модуль не входит в тариф Free, вам нужно подключить Standard или Premium, и вы получите доступ к большому количеству функционала программы Dentist Plus.",
    title: "Название",
    to_top: "Наверх",
    today: "Сегодня",
    total: "Итого",
    translation: "Перевод",
    unknown: "Неизвестно",
    upload: "Загрузить",
    web: "Web",
    who_has_access: "Кому доступно",
    wrong_file_format: "Неверный формат файлов",
    yes: "Да"
}
